import { attr, Model, many } from 'redux-orm';
import generateRandomString from '%app/js/common/services/generateRandomString';

class TicketType extends Model {
    static modelName = 'TicketType';

    static fields = {
        id: attr(),
        hash: attr(),
        color: attr(),
        cacheKey: attr({ getDefault: () => generateRandomString() }),
        seats: many('Seat'),
        generalAdmissions: many('GeneralAdmission'),
        seatingsCount: attr({ getDefault: () => 0 }),
    };
}

export default TicketType;
